import React from "react";
import { graphql } from "gatsby";

import Layout from "../components/Layout";
import WithI18next from "../components/WithI18next";
import FormLayout from "../layouts/FormLayout";

const FormTemplate = ({ data }) => {
  return (
    <Layout
      title={data.form.seo.title || data.form.title}
      description={data.form.seo.metaDesc}
    >
      <FormLayout form={data.form} />
    </Layout>
  );
};
export default WithI18next()(FormTemplate);

export const query = graphql`
  query ($id: Int!, $wpLocale: String!, $wpGlobalConfig: String!) {
    form: wpForm(
      databaseId: { eq: $id }
      language: { locale: { eq: $wpLocale } }
      acfGlobalConfiguration: { gcLinkTo: { in: [".all", $wpGlobalConfig] } }
    ) {
      title
      content
      seo {
        title
        metaDesc
      }
    }
  }
`;
